<template>
    <div class="parent-notification">
        <PreLoader v-if="isLoading"/>
        <div v-html="$t('onlineLesson')" class="titleSchedule"/>
        <v-simple-table class="dash-tab" v-if="items.length">
            <template v-slot:default>
                <thead>
                <tr>
                    <th style="font-weight: bold; font-size: 14px">{{$t('course')}}</th>
                    <th style="font-weight: bold; font-size: 14px">{{$t('teacher')}}</th>
                    <th style="font-weight: bold; font-size: 14px"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in items" :key="i">
                    <td>{{item.course}}</td>
                    <td>{{item.instructorFio}}</td>
                    <td><a class="btn-lesson" :href="item.url" target="_blank">{{$t('joinOnlineLesson')}}</a></td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <div v-else>{{$t('notActiveLesson')}}</div>
    </div>
</template>

<script>

import OnlineLessonService from '@/_services/online-lesson.service'
import PreLoader from '@/components/preloader/PreLoader.vue'

export default {
  name: 'OnlineLesson',
  components: { PreLoader },
  data () {
    return {
      isLoading: false,
      items: []
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },
  created () {
    this.openLessonListDialog()
  },
  methods: {
    openLessonListDialog () {
      this.isLoading = true
      OnlineLessonService.getActiveLessonList(this.userProfile.user.id).then((res) => {
        if (res) this.items = res
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
.titleSchedule{
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 20px;
}
.parent-notification {
    padding: 25px;
    font-family: Helvetica, sans-serif;
}
.btn-lesson{
    font-size: 14px;
    cursor: pointer;
    color: #1976D2;
    text-decoration: none;
}

th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}

.dash-tab{
    max-width: 770px;
    margin: 0 auto;
}

</style>
